export const siteInfo = {
  name: "棱镜求证",
  fullName: "棱镜求证 · 真相核验站",
  slogan: "从一个角度看爆料，从多个角度看真相",
  description:
    "追踪社会爆料反转与官方回应，核验辟谣信息真假，提供求证视角与真相梳理。",
  email: "qiuzheng@lengjing-lens.cn",
  workingHours: "周一至周五 09:30 - 18:00",
  responseTime: "通常 1-2 个工作日内回复",
  url: "https://hzxesm.cn",
};

export interface NavItem {
  label: string;
  path: string;
}

export const navItems: NavItem[] = [
  { label: "首页", path: "/" },
  { label: "事件案例库", path: "/cases" },
  { label: "真相核验", path: "/fact-check" },
  { label: "求证指南", path: "/guide" },
  { label: "常见问题", path: "/faq" },
  { label: "关于我们", path: "/about" },
];

export const footerGroups: Array<{ title: string; links: NavItem[] }> = [
  {
    title: "内容导航",
    links: [
      { label: "首页", path: "/" },
      { label: "事件案例库", path: "/cases" },
      { label: "真相核验", path: "/fact-check" },
      { label: "求证指南", path: "/guide" },
    ],
  },
  {
    title: "了解我们",
    links: [
      { label: "关于我们", path: "/about" },
      { label: "常见问题", path: "/faq" },
      { label: "线索提交", path: "/about#contact" },
    ],
  },
];

export const principles: Array<{ icon: string; title: string; desc: string }> = [
  {
    icon: "ri-search-eye-line",
    title: "先核实，再表达",
    desc: "结论必须建立在可查证的材料之上，不因传播热度而放宽标准。",
  },
  {
    icon: "ri-time-line",
    title: "保留时间线",
    desc: "事件会变，结论也会更新。每一条核验都标注时间与最新进展。",
  },
  {
    icon: "ri-shield-check-line",
    title: "保护当事人",
    desc: "对可识别个人身份的信息进行脱敏，避免核验过程造成二次伤害。",
  },
  {
    icon: "ri-links-line",
    title: "把来源交给你",
    desc: "每条案例都列出参考来源，让你能自行复核，而不是只相信我们。",
  },
];